<template>
  <div class="form-item-container">
    <div class="questions-container">
      <div class="question-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="question-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>
    <div class="response-container">
      <div class="cursor-pointer" v-for="star in maxStars" :key="star" @click="handleClick(star)">
        <!-- <img :src="star <= currentRating ? starOnIcon : starOffIcon" /> -->
        <img v-if="star === 1" :src="star !== currentRating ? star1Icon : star1FilledIcon" />
        <img v-if="star === 2" :src="star !== currentRating ? star2Icon : star2FilledIcon" />
        <img v-if="star === 3" :src="star !== currentRating ? star3Icon : star3FilledIcon" />
        <img v-if="star === 4" :src="star !== currentRating ? star4Icon : star4FilledIcon" />
        <img v-if="star === 5" :src="star !== currentRating ? star5Icon : star5FilledIcon" />
        <div v-if="getCurrentRating === 0" class="rating-caption ion-padding-top">{{ getDefaultStarLabel(star) }}</div>
        <div v-else-if="getCurrentRating === star" class="rating-caption ion-padding-top">{{ getStarLabel(star) }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import star1Icon from '@/assets/icons/Star1.svg'
import star1FilledIcon from '@/assets/icons/Star1_filled.svg'
import star2Icon from '@/assets/icons/Star2.svg'
import star2FilledIcon from '@/assets/icons/Star2_filled.svg'
import star3Icon from '@/assets/icons/Star3.svg'
import star3FilledIcon from '@/assets/icons/Star3_filled.svg'
import star4Icon from '@/assets/icons/Star4.svg'
import star4FilledIcon from '@/assets/icons/Star4_filled.svg'
import star5Icon from '@/assets/icons/Star5.svg'
import star5FilledIcon from '@/assets/icons/Star5_filled.svg'

export default defineComponent({
  name: 'RatingStars',
  props: {
    initialRating: {
      type: Number,
      default: 0
    },
    maxStars: {
      type: Number,
      default: 5
    },
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    form_item_id: {
      type: Number,
      default: 0
    },
    form_item_order: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      star1Icon,
      star1FilledIcon,
      star2Icon,
      star2FilledIcon,
      star3Icon,
      star3FilledIcon,
      star4Icon,
      star4FilledIcon,
      star5Icon,
      star5FilledIcon,
      imageLock: false,
      currentRating: this.initialRating
    }
  },
  computed: {
    getCurrentRating (): number {
      return this.currentRating
    }
  },
  methods: {
    handleClick (rating: number) {
      this.currentRating = rating
      this.$emit('response-submitted', rating.toString())
    },
    getDefaultStarLabel (star: number) {
      switch (star) {
        case 1:
          return 'Muito mau'
        case 2:
          return ''
        case 3:
          return 'Médio'
        case 4:
          return ''
        case 5:
          return 'Muito bom'
        default:
          return ''
      }
    },
    getStarLabel (star: number) {
      switch (star) {
        case 1:
          return 'Muito mau'
        case 2:
          return 'Mau'
        case 3:
          return 'Médio'
        case 4:
          return 'Bom'
        case 5:
          return 'Muito bom'
        default:
          return ''
      }
    }
  }
})
</script>

<style scoped>
.form-item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  padding: 2em 5% 2em 5%;

  color: white;

  .questions-container {
    grid-row: 1;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;

    align-items: center;
    justify-items: center;

    padding-bottom: 2em;

    .question-primary-language {
      grid-row: 1;
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .question-secondary-language {
      grid-row: 2;
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

  .response-container {
    /* display: flex; */
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 2em;
    justify-content: center;
    padding: 1em 0em;

    img {
      width: 5em;
    }
  }
}

@media (max-width: 1024px) {
  .form-item-container {
    .response-container {
      display: flex;
      gap: 0em;
      justify-content: center;
      padding: 1em 0em;

      div img {
        /* width: 120px; */
        max-width: 70%;
      }
    }
  }

  .rating-caption {
    display: none;
  }
}

.rating-caption {
  font-size: 1.5em;
  text-align: center;
  min-width: 4em;
}

.star-container {
  padding: 0 32px;
}

.cursor-pointer {
  cursor: pointer;
  text-align: center;
}
</style>
